import { RefreshIcon } from "~/components/ui/refresh-icon";

import {
  ensureClientSettingsHydrated,
  useClientSettingsHydrationStatus,
} from "../../hooks/useSettings";
import { Button } from "../ui/button";

/**
 * Holds back the app tree until client settings are read, so nothing renders
 * against defaults that are about to change. A failed read shows recovery
 * without mounting the app.
 */
export function FirstRunGate({ children }: { readonly children: React.ReactNode }) {
  const hydrationStatus = useClientSettingsHydrationStatus();
  if (hydrationStatus === "failed" || hydrationStatus === "retrying") {
    const retrying = hydrationStatus === "retrying";
    return (
      <main className="flex h-dvh min-h-0 items-center justify-center bg-background px-6 text-foreground">
        <div className="flex max-w-sm flex-col items-center text-center">
          <h1 className="text-lg font-semibold">Could not read settings</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Your saved settings could not be loaded.
          </p>
          <Button
            className="mt-5"
            size="sm"
            variant="outline"
            disabled={retrying}
            onClick={() => void ensureClientSettingsHydrated().catch(() => undefined)}
          >
            <RefreshIcon refreshing={retrying} />
            Retry
          </Button>
        </div>
      </main>
    );
  }
  return hydrationStatus === "ready" ? children : null;
}
